import { useState } from 'react';
import LIVR         from 'livr';

import api          from '../../../singleton/api.js'


const accountValidator = new LIVR.Validator({
    firstName    : [ 'required' ],
    lastName     : [ 'required' ],
    email        : [ 'required', 'email' ],
    name         : [ 'required' ],
    url          : [ 'required' ],
    phone        : [ 'required' ]
});

const companyValidator = new LIVR.Validator({
    organizationIndustry : [ 'required' ],
    useCase              : [ 'required' ]
});

function useAccountPage(captchaRef) {
    const [ tab, setTab ] = useState('account');
    const [ values, setValues ] = useState({
        useCase: [],
        organizationIndustry: 'AGENCY'
    });
    const [ errors, setErrors ] = useState({});

    function handleChangeTab(name) {
        return () => {
            if (tab === 'account') {
                const validData = accountValidator.validate(values);

                if(validData) {
                    setTab(name)
                } else {
                    const err = accountValidator.getErrors();

                    setErrors(err);
                }
            } else if (tab === 'company') {
                const validData = companyValidator.validate(values);

                if(validData) {
                    setTab(name)
                } else {
                    const err = companyValidator.getErrors();

                    setErrors(err);
                }
            } else {
                setTab(name)
            }
        }
    }

    function handleChange(name) {
        return (e) => {
            const value = e.target.value;
            
            setValues(prev => ({
                ...prev,
                [name]: value
            }));

            setErrors(prev => ({
                ...prev,
                [name]: ''
            }))
        }
    }

    function handleSelectChange(name) {
        return (value) => {
            setValues(prev => ({
                ...prev,
                [name]: value
            }));

            setErrors(prev => ({
                ...prev,
                [name]: ''
            }))
        }
    }

    function handleChangeCase(value) {
        const { useCase } = values;

        if(useCase.includes(value)) {
            return setValues(prev => {
                return {
                    ...prev,
                    useCase: prev.useCase.filter(el => el !== value)
                }
            })
        }

        return setValues(prev => {
            return {
                ...prev,
                useCase: [ ...prev.useCase, value]
            }
        })
    }

    async function handleCreateAccount() {
        const captchaKey = await captchaRef.current.executeAsync();
        const {
            firstName,
            lastName,
            email,
            name,
            url,
            phone,
            organizationIndustry,
            useCase
        } = values;
        const dumpUseCase = useCase.reduce((acc, item) => {
            return {
                ...acc,
                [item]: true
            }
        }, {})
        const params = {
            firstName,
            lastName,
            email,
            phone,
            captchaKey
        }
        const payload = {
            name,
            url,
            useCase: dumpUseCase,
            organizationIndustry
        }
        try {
            await api.account.createAccount(payload, params);
            setTab('thanks')
        } catch(err) {
            console.log(err);
            throw err;
        }
    } 

    return {
        tab,
        handleChangeTab,
        handleChange,
        handleChangeCase,
        handleSelectChange,
        handleCreateAccount,
        values,
        errors
    };
}

export default useAccountPage;
